import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { SearchParams, SearchSort } from "@/entry/local/movie";
import { SearchResult } from "@/entry/server/movie";
import { Pagination } from "@/lib/api";
import { videoRepo } from "@/repo/video-repo";
import Header from "@/component/header";
import Footer from "@/component/footer";
import MoviesGrid from "@/component/commom/movies-grid";
import { useQueryParams, getQueryParam } from "@/hooks/useQueryParams";

export default function MoviesArchivePage() {
    const queryParams = useQueryParams();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [searchResult, setSearchResult] = useState<SearchResult | null>(null);
    const [pagination, setPagination] = useState<Pagination | null>(null);
    const [searchParamsObject, setSearchParamsObject] = useState<SearchParams | null>(null);
    const [pageTitle, setPageTitle] = useState("");

    useEffect(function () {
        setLoading(true);
        var imdbRate = getQueryParam(queryParams, "imdb_rate", "0");
        var isDubbed = getQueryParam(queryParams, "is_dubbed", "");
        var isSubbed = getQueryParam(queryParams, "is_subbed", "");
        var genre = getQueryParam(queryParams, "genre", "0");
        var sort = getQueryParam(queryParams, "sort", "");
        var page = getQueryParam(queryParams, "page", "1");
        var title = getQueryParam(queryParams, "title", "");

        var paramsObject: SearchParams = {
            type: "movie",
            imdb_rate: parseFloat(imdbRate),
            is_dubbed: isDubbed === "true",
            is_subbed: isSubbed === "true",
            genre: parseInt(genre, 10),
            sort: sort as SearchSort,
            page: parseInt(page, 10),
        };

        videoRepo.search(paramsObject).then(function (result) {
            var resolvedTitle = title;
            if (!resolvedTitle) {
                resolvedTitle = "فیلم ها";
            }
            if (result.data) {
                setSearchResult(result.data);
            }
            if (result.pagination) {
                setPagination(result.pagination);
            }
            setSearchParamsObject(paramsObject);
            setPageTitle(resolvedTitle);
            setLoading(false);
        });
    }, [location.search]);

    if (loading || !searchResult || !pagination || !searchParamsObject) {
        return (
            <div className="page-loading">
                <div className="loader" />
            </div>
        );
    }

    return (
        <>
            <Header />
            <MoviesGrid
                defaultSearchResult={searchResult}
                defaultPagination={pagination}
                title={pageTitle}
                defaultSearchParams={searchParamsObject}
                allowType={false}
                />
            <Footer />
        </>
    );
}
